import React, { FC, memo } from "react";
import { IGLSParcel } from "@montana/models/generated/cms.interface";

interface IParcelShopProps {
    shop: IGLSParcel;
}

export const ParcelShop: FC<IParcelShopProps> = memo(({ shop }: IParcelShopProps) => (
    <>
        <div>
            {shop.companyName}
        </div>
        <div>
            {shop.streetname}
        </div>
        <div>
            {shop.streetname2}
        </div>
        <div>
            {shop.zipCode} {shop.cityName}
        </div>
    </>
));
